const firebaseConfig = {
    apiKey: "AIzaSyAFd9_jN7k3t2NFjck3Se1PNFi6DNGfE7k",
    authDomain: "my-kalory.firebaseapp.com",
    projectId: "my-kalory",
    storageBucket: "my-kalory.appspot.com",
    messagingSenderId: "509159030580",
    appId: "1:509159030580:web:0193babafe531b1c1eef61",
    measurementId: "G-1RW75PRGLG"
  };

export default firebaseConfig;